<h3 class="ui primary header">Upload Logo
  <i class="link times icon" (click)="modal.deny(undefined)"></i>
</h3>
<div class="content">
  <div class="scroll-wrapper ui basic segment" [ngClass]="{'loading':pending}">
    <div *ngIf="success || error" tamsyMargin marginY="10px">
      <esl-message-toast [(message)]="success" [messageType]="'success'"></esl-message-toast>
      <esl-message-toast [(message)]="error"></esl-message-toast>
    </div>
    <!--Project information -->

    <div class="ui form side-panel" fxLayout="row" fxLayoutAlign='start center' fxLayoutGap='50px' appPadding="15px"
      appMargin marginB="30px">

      <svg *ngIf="!image" fxFlex="10%" width="52" height="52" viewBox="0 0 52 52" fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <rect x="1" y="1" width="50" height="50" rx="5" stroke="#999999" stroke-width="2" stroke-dasharray="4 4" />
      </svg>
      <div *ngIf="image" fxFlex="10%" width="52" height="52">
        <img [src]="image" />
      </div>

      <div fxFlex="grow">Upload Picture</div>
      <div fxFlex>
        <input hidden type="file"  accept=".jpg, .jpeg, .png" #uploader (change)="uploadImage($event.target.files)"
           placeholder="Browse for documents" onclick="value = null">
        <button class="ui tiny icon button" suiPopup [popupInverted]="true" popupText="Select file"
          (click)="uploader.click()">
          <i class="upload icon"></i>
        </button>
      </div>
    </div>
  </div>
</div>
<div class="actions" appMargin marginT="80">
  <button class="ui  basic button" [ngClass]="{'yellow':pending}" [disabled]="pending" (click)="close()"
    autofocus>Cancel</button>

  <button class="ui  primary button" [ngClass]="{'yellow':pending}" [disabled]="pending" (click)="submit()"
    autofocus>Upload</button>

</div>
